import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tr[paTableGroupRow]',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pa-table-group-row.component.html',
  styleUrls: ['./pa-table-group-row.component.scss'],
})
export class PaTableGroupRowComponent {
  @Input() colspan = 1;
  @Input() title = '';
  @Input() subtitle?: string;
  @Input() expanded = true;

  @Output() groupRowToggle = new EventEmitter<void>();

  handleToggle(): void {
    this.groupRowToggle.emit();
  }
}

